// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: gateway KONVO_CORNER_UPDATE: `{suggestion}` when one is due or changed, `{removed: id}` when
// the server took it away (skipped, used on another device, expired). Ignored while the new
// assistant experience is not switched on for this person (the rollout).

import type {GatewayHandlerContext} from '@app/features/gateway/events/EventRouter';
import Corner from '@app/features/konvo_corner/state/Corner';
import EngagementAccess from '@app/features/konvo_engagement/state/EngagementAccess';
import {type CornerSuggestion, CornerSuggestionSchema} from '@fluxer/schema/src/domains/konvo/AssistantEngagement';

export function handleKonvoCornerUpdate(data: unknown, _context: GatewayHandlerContext): void {
	if (!data || typeof data !== 'object' || !EngagementAccess.enabled) return;
	const event = data as {suggestion?: unknown; removed?: unknown};
	const removed = typeof event.removed === 'string' ? event.removed : undefined;
	let suggestion: CornerSuggestion | undefined;
	if (event.suggestion) {
		const parsed = CornerSuggestionSchema.safeParse(event.suggestion);
		if (parsed.success) suggestion = parsed.data;
	}
	if (!removed && !suggestion) return;
	Corner.applyUpdate({suggestion, removed});
}
